module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-mentor-dark.76a69234.png";